// Import Modules
import { useEffect } from "react";

// Import Config
import ClevertapClient from "../../config/clevertapClient";

// Import Constants
import { CLEVERTAP_ID } from "../../constants/clevertapConfig";

const CleverTap = () => {
  useEffect(() => {
    ClevertapClient.initialize(CLEVERTAP_ID);
  }, []);

  return null;
};

export default CleverTap;
